import { Fragment } from "react";
import appstore from "@assets/appStore.png";
import playstore from "@assets/gplay.png";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { textVariants } from "./Text/Text";
import { useTheme } from "../context/themeContext";
import Twitter from "../svg/twitter";
import Ig from "../svg/ig";
import Fb from "../svg/fb";
import Yt from "../svg/yt";
import Logo from "../svg/logo";
import LanguageSwitcher from "./langSwitcher";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  const trans = (key: string) => t(`app.footer.${key}`);
  return (
    <Fragment>
      <footer
        className="bg-[#EDF0FA] dark:bg-grey-700"
        aria-labelledby="footer-heading"
      >
        <div className=" mx-auto pt-12 px-4 w-full xl:max-w-6xl sm:px-6 lg:pt-16 lg:px-8">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="space-y-4 xl:col-span-1">
              <Logo
                height={"30px"}
                width={"150px"}
                color={theme === "dark" ? "white" : undefined}
              />

              <div className="flex  space-x-6">
                <a
                  href="https://facebook.com/mybitstore"
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Facebook</span>
                  <Fb
                    height={"16px"}
                    width={"16px"}
                    color={theme === "dark" ? "white" : "black"}
                  />
                </a>

                <a
                  href="https://instagram.com/mybitstore_app/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Instagram</span>
                  <Ig
                    height={"16px"}
                    width={"16px"}
                    color={theme === "dark" ? "white" : "black"}
                  />
                </a>

                <a
                  href="https://twitter.com/mybitstore"
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Twitter</span>
                  <Twitter
                    height={"16px"}
                    width={"16px"}
                    color={theme === "dark" ? "white" : "black"}
                  />
                </a>
                <a
                  href="https://youtube.com/channel/UCF2J6gWekpTk4jh63RbPVlw"
                  target="_blank"
                  rel="noreferrer"
                  className="text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">Twitter</span>
                  <Yt
                    height={"16px"}
                    width={"16px"}
                    color={theme === "dark" ? "white" : "black"}
                  />
                </a>
              </div>
              <LanguageSwitcher />
              <div className="mx-auto my-3 flex space-x-3 justify-start max-w-7xl">
                <Link
                  target="_blank"
                  rel="noreferrer"
                  to="https://play.google.com/store/apps/details?id=app.mybitstore.com"
                >
                  <img
                    className="md:h-10 h-12 md:w-32"
                    src={playstore}
                    alt="android"
                  />
                </Link>
                <Link
                  target="_blank"
                  rel="noreferrer"
                  to="https://apps.apple.com/us/app/mybitstore-buy-sell-bitcoin/id1579519877"
                >
                  <img
                    className="md:h-10 h-12 md:w-32"
                    src={appstore}
                    alt="ios"
                  />
                </Link>
              </div>
            </div>
            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-8 xl:mt-0 xl:col-span-2">
              <div className="mt-12 md:mt-0">
                <h3
                  className={textVariants({
                    size: "sm",
                    font: "semibold",
                    spacing: "wider",
                    case: "uppercase",
                  })}
                >
                  {trans("product.title")}
                </h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      to="/app/trade/buy"
                    >
                      {trans("product.buySell")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      to="/app/trade/buy"
                    >
                      {trans("product.buySellUSDT")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target="_blank"
                      to="https://mybitstore.com/bulktrade"
                    >
                      {trans("product.otcTrade")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target="_blank"
                      to="https://mybitstore.com/referandearn"
                    >
                      {trans("product.becomeReferrer")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3
                  className={textVariants({
                    size: "sm",
                    font: "semibold",
                    spacing: "wider",
                    case: "uppercase",
                  })}
                >
                  {trans("help.title")}
                </h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target="_blank"
                      to="https://mybitstore.com/contact"
                    >
                      {trans("help.support")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target={"_blank"}
                      to="https://mybitstore.com/faq"
                    >
                      {trans("help.faq")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="https://blog.mybitstore.com"
                      target="_blank"
                      rel="noreferrer"
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                    >
                      {trans("help.blog")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target={"_blank"}
                      to="https://mybitstore.com/feesandrates"
                    >
                      {trans("help.feesRates")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3
                  className={textVariants({
                    size: "sm",
                    font: "semibold",
                    spacing: "wider",
                    case: "uppercase",
                  })}
                >
                  {trans("company.title")}
                </h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target={"_blank"}
                      to="https://mybitstore.com/about"
                    >
                      {trans("company.aboutUs")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target={"_blank"}
                      to="https://mybitstore.com/privacy"
                    >
                      {trans("company.privacy")}
                    </Link>
                  </li>

                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target={"_blank"}
                      to="https://mybitstore.com/terms"
                    >
                      {trans("company.terms")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3
                  className={textVariants({
                    size: "sm",
                    font: "semibold",
                    spacing: "wider",
                    case: "uppercase",
                  })}
                >
                  {trans("legal.title")}
                </h3>
                <ul className="mt-4 space-y-4">
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target={"_blank"}
                      to="https://mybitstore.com/risks"
                    >
                      {trans("legal.risk")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target={"_blank"}
                      to="https://mybitstore.com/aml"
                    >
                      {trans("legal.kyc")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={cn(
                        textVariants({ variant: "desc", font: "light" }),
                        "hover:text-gray-900"
                      )}
                      target={"_blank"}
                      to="https://mybitstore.com/refund"
                    >
                      {trans("legal.refund")}
                    </Link>
                  </li>
                </ul>
              </div>
              {/* </div> */}
            </div>
          </div>
          <div className="mt-12 border-t border-gray-200 dark:border-grey-400 py-8">
            <p
              className={cn(
                textVariants({ variant: "desc", font: "light" }),
                " xl:text-center"
              )}
            >
              &copy; {new Date().getFullYear()} Mybitstore Technologies LTD. All
              rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </Fragment>
  );
};

export default Footer;
